import React from "react";
import { Stack, IconButton, Icon, Typography, Card } from "@mui/material";
import { useSearchParams } from "react-router-dom";
import { Avatar } from "@mui/material";
import { PackageIcon } from "routes";
// import AwsTarget from "pages/Targets/components/AwsTarget";
import Input from "common/components/Input";
import Modal from "common/components/Modal";
import List from "common/components/List";
import Blurb from "constants/blurbs";
import { nanoid } from "nanoid";
import validate from "constants/validate";
import ActionButton from "common/components/ActionButton";
import SectionHeader from "common/components/SectionHeader";
import MultiSelect from "common/components/MultiSelect";
import useFetcher from "common/hooks/useFetcher";
import { useNavigate } from "react-router-dom";
import useScopeAttributes from "common/hooks/useScopeAttributes";
import toast from "react-hot-toast";
import SidePanel from "common/components/SidePanel";
const SOURCE_LIST = [
  { name: "PyPI", id: 0 },
  { name: "Echelon One", id: 1 },
];

export default function TestPackage({ system, command, edit, onClose }) {
  const [pkg, setPackage] = React.useState("");
  const [loading, setLoading] = React.useState(false);
  const [e1pkg, setE1PackageSelect] = React.useState(null);
  const [e1pkgVer, setE1PkgVer] = React.useState(null);
  const [availableE1Pkgs, setAvailableE1Pkgs] = React.useState([]);
  const navigate = useNavigate();
  const [source, setSource] = React.useState("0");
  const [packages, setPackages] = React.useState([]);
  let [searchParams, setSearchParams] = useSearchParams();
  const fetcher = useFetcher();

  const fetchPkgs = async () => {
    setLoading(true);
    await fetcher.get(
      "fetching packages",
      `/api/pkg`,
      ({ packages }) => {
        setAvailableE1Pkgs(packages);
        setLoading(false);
      },
      () => {
        setLoading(false);
      }
    );
    setLoading(false);
  };
  React.useEffect(() => {
    if (edit) {
      fetchPkgs();
    }
  }, [edit]);
  const onSave = async (close) => {
    await fetcher.post(
      "updating package for testing",
      `/api/pkg/${e1pkg?.name}/testing`,
      {
        system_id: system.id,
        system_name: system.name,
        cmd_id: command.id,
        cmd_name: command.name,
      },
      (data) => {
        if (data?.error) return toast.error(data?.error);
        navigate(`/app/packages/${e1pkg?.name}?version=0`);
      },
      () => {}
    );
    close();
    // let payload = {};
    // if (source === "1") {
    //   let packageName = e1pkg?.name + "==" + e1pkgVer;
    //   if (!validate("command_local_package_edit", { pkg: packageName, source }))
    //     return;
    //   payload = { pkg: packageName, source };
    // } else {
    //   if (!validate("command_package_edit", { pkg })) return;
    //   payload = { pkg };
    // }
    // if (edit?.id) {
    //   setData({
    //     ...data,
    //     packages: packages.map((i) => {
    //       if (i.id !== edit?.id) return i;
    //       return { ...payload, id: edit?.id };
    //     }),
    //   });
    // } else {
    //   setData({
    //     ...data,
    //     packages: [...data.packages, { id: nanoid(), ...payload }],
    //   });
    // }
    // setE1PackageSelect(null);
    // setE1PkgVer(null);
    // setPackage("");
    // setSource("0");
    // close();
  };

  return (
    <Modal
      forceOpen={edit}
      onClose={() => {
        setE1PackageSelect(null);
        onClose();
      }}
    >
      {({ handleClose }) => (
        <Stack gap={2}>
          <SectionHeader icon="archive">Test Package</SectionHeader>

          <MultiSelect
            getOptionLabel={(e) => e.name}
            getOptionKey={(e) => e.name}
            options={availableE1Pkgs || []}
            loading={loading}
            label="Package"
            multiple={false}
            placeholder="select a package"
            value={e1pkg}
            setValue={(e) => setE1PackageSelect(e)}
            dark
            size="small"
          />

          <div style={{ marginLeft: "auto" }}>
            <ActionButton
              handler={() => onSave(handleClose)}
              noload
              icon="archive"
              disabled={!e1pkg?.pk}
            >
              Confirm Testing
            </ActionButton>
          </div>
        </Stack>
      )}
    </Modal>
  );
}
